import { Link } from 'react-router-dom';

export function GuaranteePage() {
  return (
    <div>
      <section className="bg-gradient-to-br from-navy via-navy-600 to-navy-700 text-white">
        <div className="mx-auto max-w-4xl px-4 py-16 text-center">
          <p className="text-orange font-semibold uppercase tracking-wider text-sm mb-3">
            The TowShare Promise
          </p>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">$1,500 Trailer Guarantee</h1>
          <p className="text-lg text-navy-100 max-w-2xl mx-auto">
            Every rental is backed by up to <strong className="text-white">$1,500</strong> of
            TowShare-funded damage coverage, on top of the renter's auto insurance and a
            refundable damage deposit. Owners are covered. Renters are protected.
          </p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 py-16 space-y-8">
        <Card title="How owners are protected">
          <ul className="list-disc pl-5 space-y-2 text-navy-700">
            <li>
              <strong>Damage deposit</strong> on every booking, pre-authorized via Stripe and
              held until 24 hours after the trailer is returned.
            </li>
            <li>
              <strong>$1,500 TowShare Guarantee</strong> tops up beyond the deposit when
              damage exceeds what the renter's coverage handles.
            </li>
            <li>
              <strong>Renter ID verification</strong> through Stripe Identity is required
              before the first booking.
            </li>
            <li>
              <strong>Mutual photo handoff</strong> at pickup and return creates a clear
              record of the trailer's condition.
            </li>
          </ul>
        </Card>

        <Card title="How renters are protected">
          <ul className="list-disc pl-5 space-y-2 text-navy-700">
            <li>
              <strong>Payments through Stripe</strong> — your card is only charged once the
              owner confirms the booking.
            </li>
            <li>
              <strong>Dispute support.</strong> If something goes wrong, our team mediates
              between you and the owner.
            </li>
            <li>
              <strong>Reviews on both sides</strong> keep the marketplace honest.
            </li>
          </ul>
        </Card>

        <Card title="What's not covered">
          <ul className="list-disc pl-5 space-y-2 text-navy-700">
            <li>Pre-existing damage that wasn't flagged on the pre-rental photo handoff.</li>
            <li>Theft of contents loaded onto the trailer by the renter.</li>
            <li>Off-road or commercial use unless explicitly allowed by the owner.</li>
            <li>Damage caused by exceeding the trailer's rated capacity.</li>
          </ul>
        </Card>

        <Card title="Insurance: how it actually works">
          <p className="text-navy-700 mb-3">
            In Canada, your <strong>auto insurance follows the trailer</strong> while you're
            towing it. Your liability and (in most cases) collision coverage extend to the
            trailer attached to your vehicle. Check with your insurer before your first
            rental — most policies cover utility trailers automatically.
          </p>
          <p className="text-navy-700">
            On top of that, TowShare's <strong>$1,500 Trailer Guarantee</strong> backs the
            owner if damage exceeds the deposit and the renter's auto policy. We don't sell
            insurance — we sit on top of yours.
          </p>
          <p className="mt-4">
            <Link to="/insurance" className="text-orange font-medium hover:underline">
              Read more about insurance and coverage →
            </Link>
          </p>
        </Card>

        <div className="text-center pt-4">
          <Link to="/list-your-trailer" className="btn-primary">
            List your trailer
          </Link>
        </div>
      </section>
    </div>
  );
}

function Card({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <div className="card p-6">
      <h2 className="text-xl font-semibold text-navy mb-3">{title}</h2>
      {children}
    </div>
  );
}
